export class GetIdpGroupResponse {
    'group';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "group",
            "baseName": "group",
            "type": "IdpGroup",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetIdpGroupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
